import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "test"
const create = function () {
    return {
        content_type: "muji",
        age: 29
    }
}

const descriptor = {
    name: {
        type: 'string',
        required: true,
        validator: (rule, value) => value === 'muji',
    },
    age: {
        type: 'number',
        asyncValidator: (rule, value) => {
            return new Promise((resolve, reject) => {
                api.request({
                    url: biz_data_helper.get_endpoint("test_fetch").url,
                    parameters: { c: "a666" },
                }).then((res) => {


                    if (value == res.data[0].echo) {
                        resolve(res)

                    } else {
                        reject("测试没通过")
                    }
                }).catch((err) => { reject(err) })
            });
        },
    },
};


const entity_helper = new biz_data_helper.base_entity_helper(content_type, create, descriptor)

export * from "../../shared/biz_data_helper"
export default entity_helper
